var _defs, _path, _g, _path2, _ellipse, _ellipse2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1dacf;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-7{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-3{stroke:#fff;}.cls-4{fill:#7f7c78;}.cls-5{fill:#e24134;}.cls-6{clip-path:url(#clip-path-2);}.cls-7{stroke:#000;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.68,241.1a34,34,0,0,0-5.07-9.46c-10.71-14-31.64-18.19-48.59-8.54C1109,323.26,942.09,511.83,942.09,511.83l34.5,34,21.15,63.44c43.56-11.29,51.91-45.45,53.3-62.48a39,39,0,0,1,7.32-19.76l37.34-51.34a193.81,193.81,0,0,1,42.17-42.35L1347.22,279.7C1359.26,270.86,1364.59,255.21,1359.68,241.1Zm-33.9,23.73a15.3,15.3,0,1,1,15.3-15.3A15.3,15.3,0,0,1,1325.78,264.83Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 591.51,
    cy: 686.9,
    rx: 401.77,
    ry: 225.26,
    transform: "translate(-48.39 44.84) rotate(-4.17)"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1359.68,241.1a34,34,0,0,0-5.07-9.46c-10.71-14-31.64-18.19-48.59-8.54C1109,323.26,942.09,511.83,942.09,511.83l34.5,34,21.15,63.44c43.56-11.29,51.91-45.45,53.3-62.48a39,39,0,0,1,7.32-19.76l37.34-51.34a193.81,193.81,0,0,1,42.17-42.35L1347.22,279.7C1359.26,270.86,1364.59,255.21,1359.68,241.1Zm-33.9,23.73a15.3,15.3,0,1,1,15.3-15.3A15.3,15.3,0,0,1,1325.78,264.83Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1038.24 511.83 1089.61 443.17 1270.29 312.01"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M899.8,540.29l42.29-28.46,43,22a23.29,23.29,0,0,1,12.68,20.73v54.76L975.48,626Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 606.81,
    cy: 734.56,
    rx: 391.63,
    ry: 217.43,
    transform: "translate(-51.82 46.08) rotate(-4.17)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 591.51,
    cy: 686.9,
    rx: 401.77,
    ry: 225.26,
    transform: "translate(-48.39 44.84) rotate(-4.17)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.89,
    cy: 793.14,
    rx: 306.39,
    ry: 175.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M262.29,609.29S452.19,450.9,723.18,495"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects12);
export default __webpack_public_path__ + "static/media/objects-12.ef571dda6e858317a01ef1328356286a.svg";
export { ForwardRef as ReactComponent };